import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import configureAppStore from "./redux/configureStore";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { themeConfig } from "./theme";
import { Provider } from "react-redux";
import AppRoutes from "./AppRoutes";
import { installContractGuard } from "./utils/contract_guard";

// Install the X-WL-Contract drift tripwire before any API calls fire.
installContractGuard();

const preloadedState = {};

const store = configureAppStore(preloadedState);

const theme = createTheme(themeConfig);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      {/* Establishes the theme's baseline on <body>: background.default and,
          crucially, `color: text.primary`. Without it MUI never sets a body
          text colour, so every <Typography> that doesn't pass an explicit
          `color` inherited the browser default (black) and rendered invisible
          on the near-black dark surface — which is why the admin section
          headers (h5/h6/subtitle) were unreadable. This is the owner of that
          invariant; fixing it here makes all uncoloured text legible app-wide
          rather than patching a `color` onto each Typography. */}
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);
